import {HTMLAttributes, useMemo} from 'react';
import {colors} from 'patient-ping-remedy/packages/theme';
import {SmallTypography} from 'patient-ping-remedy/packages/typography';
import Icon, {ICONS} from 'patient-ping-remedy/packages/icon';
import {StyleType} from 'patient-ping-remedy/packages/button';
import {UploadPhotoArea, Photo, CustomIconButton} from '@clients/profile_page/ClientPhotoPreview.styles';

type Props = HTMLAttributes<HTMLDivElement> & {
  photo: Blob | null;
  isLoading?: boolean;
  isEditable?: boolean;
  onClick?(): void;
}

export default function ClientPhotoPreview({ photo, isLoading, isEditable, onClick, ...props }: Props) {
  const src = useMemo(() => !!photo?.size && URL.createObjectURL(photo), [photo]);

  return (
    <UploadPhotoArea isEditable={isEditable} {...props}>
      {!isLoading && src && (
        <Photo src={src} />
      )}
      {isEditable && (
        <CustomIconButton
          data-testid="upload-photo-button"
          iconClass={src ? ICONS.pencil : ICONS.plus}
          styleType={StyleType.SECONDARY}
          onClick={onClick}
        />
      )}
      <Icon
        iconClass={isLoading ? ICONS.spinner : ICONS.image}
        spin={isLoading}
        color={colors.purple4}
        iconSize="2x"
      />
      {(isLoading || isEditable) && (
        <SmallTypography color={colors.purple5}>
          {isLoading ? 'Loading' : 'Choose photo'}
        </SmallTypography>
      )}
    </UploadPhotoArea>
  );
}
